






































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Historico } from '../../../../back/src/entity/Historico';
import { HistoricoResposta } from '../../../../back/src/entity/HistoricoResposta';
import { HistoricoRespostaFormData } from '../../../../back/src/types';

import TheHistoricoRespostaItem from './TheHistoricoRespostaItem.vue';
import TheHistoricoRespostaPergunta from './TheHistoricoRespostaPergunta.vue';

export default Vue.extend({
  name: 'TheHistoricoTab',
  components: {
    TheHistoricoRespostaItem,
    TheHistoricoRespostaPergunta,
  },
  props: {
    historico: {
      type: Object as () => Historico,
    },
    verTodas: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: {
        finalizar: false,
      },
    };
  },
  computed: {
    respostas(): HistoricoResposta[] {
      if (_.has(this.historico, 'historicos_respostas')) {
        return _.sortBy(this.historico.historicos_respostas, el => el.historico_pergunta.ordem);
      }
      return [] as HistoricoResposta[];
    },
  },
  methods: {
    verItem(resposta: HistoricoResposta) {
      if (!this.verTodas) {
        if (resposta
          && resposta.historico_pergunta
          && resposta.historico_pergunta.opcoes
          && resposta.historico_pergunta.opcoes[1] === 'Não'
          && resposta.resposta === '1'
          && !resposta.observacoes
        ) {
          return false;
        }
      }
      return true;
    },
    async finalizar() {
      this.loading.finalizar = true;
      const historicoRespostaFormDataStore = _.filter(
        this.$store.getters.historicoRespostaFormData as HistoricoRespostaFormData[],
        el => (el.historico_id === this.historico.id),
      );
      if (historicoRespostaFormDataStore.length > 0) {
        try {
          const response = await Requester.historico.historicosRespostas(
            historicoRespostaFormDataStore,
          );
          if (response.errors.length > 0) {
            this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
            this.loading.finalizar = false;
            return;
          }
          this.$emit('respostaAtualizada', response.data);
        } catch (err) {
          this.$root.$emit('requestError', err);
          this.loading.finalizar = false;
          return;
        }
      }
      const formData = {
        historicoId: this.historico.id,
      };
      try {
        const response = await Requester.historico.historicoFinalizar(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Histórico finalizado com sucesso',
          });
          this.$emit('historicoFinalizado', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.finalizar = false;
      }
    },
  },
});
